export const GROUP_NODE_MAIN_SHAPE_NAME = 'mainShape';
